//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        options: {
            type: Array,
            default: () => ([])
        },
        selected: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            inner_options: this.options,
            inner_selected: []
        }
    },
    destroyed () {
        this.inner_selected = []
    },
    watch: {
        options: {
            handler (latest) {
                if (Object.is(latest, this.inner_options)) {
                    this.inner_options = latest.slice(0)
                }
            },
            immediate: true
        },
        selected: {
            handler (latest) {
                if (latest != this.inner_selected.join(',')) {
                    this.inner_selected = latest ? latest.split(',') : []
                    this.inner_options.forEach((opt) => {
                        opt.selected = this.inner_selected.indexOf(opt.value) > -1
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        onSelect (val, i) {
            const index = this.inner_selected.indexOf(val)
            if (index > -1) {
                this.inner_selected.splice(index, 1)
            } else {
                this.inner_selected.push(val)
            }
            this.inner_options[i].selected = index === -1
            const selected_text = this.inner_options.reduce((prev, { value, text, selected }) => {
                if (selected) {
                    prev.push(text || value)
                }
                return prev
            }, []).join(',')
            this.$emit('change', this.inner_selected, selected_text)
        }
    }
}
